import { render, staticRenderFns } from "./VaSeparator.demo.vue?vue&type=template&id=292bcd1d&"
import script from "./VaSeparator.demo.vue?vue&type=script&lang=js&"
export * from "./VaSeparator.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports